// Mock data for the Admin Panel and Client Portal
// This data will be stored in localStorage for persistence

export const initialMockData = {
  // Company Information
  company: {
    id: 1,
    name: "Techoside",
    logo: "/logo.png",
    address: "123 Tech Street, Innovation City, IN 400001",
    phone: "+91 9876543210",
    email: "contact@techoside.com",
    gstNumber: "27AABCT1234F1Z5",
    website: "https://techoside.com",
    bankDetails: {
      bankName: "HDFC Bank",
      accountNumber: "50100123456789",
      ifscCode: "HDFC0001234",
      accountHolder: "Techoside Pvt Ltd",
    },
  },

  // Admin Users
  admins: [
    {
      id: 1,
      name: "Admin User",
      email: "admin@techoside.com",
      username: "admin",
      password: "admin123",
      role: "Super Admin",
      avatar: null,
      createdAt: "2024-01-01",
    },
  ],

  // Employees
  employees: [
    {
      id: 1,
      name: "Rahul Sharma",
      email: "rahul@techoside.com",
      phone: "+91 9876543211",
      role: "Senior Developer",
      department: "Development",
      joiningDate: "2023-06-15",
      salary: 75000,
      status: "active",
      avatar: null,
    },
    {
      id: 2,
      name: "Priya Patel",
      email: "priya@techoside.com",
      phone: "+91 9876543212",
      role: "UI/UX Designer",
      department: "Design",
      joiningDate: "2023-08-20",
      salary: 65000,
      status: "active",
      avatar: null,
    },
    {
      id: 3,
      name: "Amit Kumar",
      email: "amit@techoside.com",
      phone: "+91 9876543213",
      role: "Project Manager",
      department: "Management",
      joiningDate: "2023-03-10",
      salary: 90000,
      status: "active",
      avatar: null,
    },
    {
      id: 4,
      name: "Sneha Reddy",
      email: "sneha@techoside.com",
      phone: "+91 9876543214",
      role: "Full Stack Developer",
      department: "Development",
      joiningDate: "2024-01-05",
      salary: 70000,
      status: "active",
      avatar: null,
    },
    {
      id: 5,
      name: "Vikram Singh",
      email: "vikram@techoside.com",
      phone: "+91 9876543215",
      role: "QA Engineer",
      department: "Quality Assurance",
      joiningDate: "2023-11-12",
      salary: 55000,
      status: "inactive",
      avatar: null,
    },
  ],

  // Teams
  teams: [
    {
      id: 1,
      name: "Web Development Team",
      leaderId: 1,
      memberIds: [1, 4],
      projectIds: [1, 3],
      createdAt: "2023-06-20",
    },
    {
      id: 2,
      name: "Design Team",
      leaderId: 2,
      memberIds: [2],
      projectIds: [1, 2],
      createdAt: "2023-08-25",
    },
    {
      id: 3,
      name: "Mobile App Team",
      leaderId: 4,
      memberIds: [4, 5],
      projectIds: [2],
      createdAt: "2024-01-10",
    },
  ],

  // Clients
  clients: [
    {
      id: 1,
      name: "John Smith",
      companyName: "TechStart Inc.",
      email: "john@techstart.com",
      phone: "+1 555-123-4567",
      loginId: "CLIENT001",
      password: "client123",
      notes: "Premium client, requires weekly updates",
      status: "active",
      createdAt: "2024-01-15",
    },
    {
      id: 2,
      name: "Sarah Johnson",
      companyName: "Digital Solutions LLC",
      email: "sarah@digitalsolutions.com",
      phone: "+1 555-234-5678",
      loginId: "CLIENT002",
      password: "client123",
      notes: "New client, first project",
      status: "active",
      createdAt: "2024-02-20",
    },
    {
      id: 3,
      name: "Michael Brown",
      companyName: "E-Commerce Pro",
      email: "michael@ecommercepro.com",
      phone: "+1 555-345-6789",
      loginId: "CLIENT003",
      password: "client123",
      notes: "Long-term partnership",
      status: "active",
      createdAt: "2023-09-10",
    },
  ],

  // Projects
  projects: [
    {
      id: 1,
      name: "TechStart Website Redesign",
      type: "Website Development",
      clientId: 1,
      teamId: 1,
      startDate: "2024-02-01",
      deadline: "2024-04-30",
      status: "development",
      budget: 150000,
      description:
        "Complete website redesign with modern UI/UX, responsive design, and CMS integration.",
      progress: 65,
      stages: [
        {
          name: "Requirement Discussion",
          status: "completed",
          date: "2024-02-01",
        },
        { name: "Design", status: "completed", date: "2024-02-20" },
        { name: "Development", status: "in_progress", date: "2024-03-01" },
        { name: "Testing", status: "pending", date: null },
        { name: "Launch", status: "pending", date: null },
        { name: "Maintenance", status: "pending", date: null },
      ],
      updates: [
        {
          id: 1,
          message: "Homepage design completed",
          date: "2024-02-25",
          type: "milestone",
        },
        {
          id: 2,
          message: "Backend API development started",
          date: "2024-03-05",
          type: "update",
        },
        {
          id: 3,
          message: "User authentication module completed",
          date: "2024-03-15",
          type: "milestone",
        },
      ],
    },
    {
      id: 2,
      name: "Digital Solutions Mobile App",
      type: "Mobile Application",
      clientId: 2,
      teamId: 3,
      startDate: "2024-03-01",
      deadline: "2024-06-30",
      status: "design",
      budget: 250000,
      description:
        "Cross-platform mobile application for inventory management with real-time sync.",
      progress: 30,
      stages: [
        {
          name: "Requirement Discussion",
          status: "completed",
          date: "2024-03-01",
        },
        { name: "Design", status: "in_progress", date: "2024-03-15" },
        { name: "Development", status: "pending", date: null },
        { name: "Testing", status: "pending", date: null },
        { name: "Launch", status: "pending", date: null },
        { name: "Maintenance", status: "pending", date: null },
      ],
      updates: [
        {
          id: 1,
          message: "Requirements finalized",
          date: "2024-03-10",
          type: "milestone",
        },
        {
          id: 2,
          message: "Wireframes approved",
          date: "2024-03-20",
          type: "update",
        },
      ],
    },
    {
      id: 3,
      name: "E-Commerce Platform",
      type: "E-Commerce",
      clientId: 3,
      teamId: 1,
      startDate: "2023-10-01",
      deadline: "2024-02-28",
      status: "completed",
      budget: 300000,
      description:
        "Full-featured e-commerce platform with payment gateway integration and admin panel.",
      progress: 100,
      stages: [
        {
          name: "Requirement Discussion",
          status: "completed",
          date: "2023-10-01",
        },
        { name: "Design", status: "completed", date: "2023-10-20" },
        { name: "Development", status: "completed", date: "2023-11-15" },
        { name: "Testing", status: "completed", date: "2024-01-30" },
        { name: "Launch", status: "completed", date: "2024-02-15" },
        { name: "Maintenance", status: "completed", date: "2024-02-28" },
      ],
      updates: [
        {
          id: 1,
          message: "Project completed successfully",
          date: "2024-02-28",
          type: "milestone",
        },
      ],
    },
  ],

  // Asset Checklists (per project)
  assetChecklists: [
    {
      id: 1,
      projectId: 1,
      items: [
        {
          id: 1,
          name: "Company Logo",
          status: "verified",
          uploadedFile: "techstart-logo.png",
          uploadedAt: "2024-02-05",
        },
        {
          id: 2,
          name: "Brand Colors & Guidelines",
          status: "verified",
          uploadedFile: "brand-guidelines.pdf",
          uploadedAt: "2024-02-06",
        },
        {
          id: 3,
          name: "Content Text (Homepage)",
          status: "uploaded",
          uploadedFile: "homepage-content.docx",
          uploadedAt: "2024-03-01",
        },
        {
          id: 4,
          name: "Product Images",
          status: "pending",
          uploadedFile: null,
          uploadedAt: null,
        },
        {
          id: 5,
          name: "Company Details",
          status: "verified",
          uploadedFile: "company-info.pdf",
          uploadedAt: "2024-02-07",
        },
        {
          id: 6,
          name: "Social Media Links",
          status: "pending",
          uploadedFile: null,
          uploadedAt: null,
        },
      ],
    },
    {
      id: 2,
      projectId: 2,
      items: [
        {
          id: 1,
          name: "App Icon",
          status: "uploaded",
          uploadedFile: "app-icon.png",
          uploadedAt: "2024-03-10",
        },
        {
          id: 2,
          name: "Brand Colors",
          status: "verified",
          uploadedFile: "colors.pdf",
          uploadedAt: "2024-03-08",
        },
        {
          id: 3,
          name: "Product Catalog",
          status: "pending",
          uploadedFile: null,
          uploadedAt: null,
        },
        {
          id: 4,
          name: "API Documentation",
          status: "pending",
          uploadedFile: null,
          uploadedAt: null,
        },
      ],
    },
  ],

  // Documents (uploaded files)
  documents: [
    {
      id: 1,
      projectId: 1,
      name: "Project Proposal",
      fileName: "proposal.pdf",
      type: "pdf",
      size: "2.5 MB",
      uploadedBy: "admin",
      uploadedAt: "2024-02-01",
    },
    {
      id: 2,
      projectId: 1,
      name: "Design Mockups",
      fileName: "mockups.zip",
      type: "zip",
      size: "15 MB",
      uploadedBy: "admin",
      uploadedAt: "2024-02-20",
    },
    {
      id: 3,
      projectId: 2,
      name: "Requirements Document",
      fileName: "requirements.pdf",
      type: "pdf",
      size: "1.2 MB",
      uploadedBy: "admin",
      uploadedAt: "2024-03-05",
    },
  ],

  // Income Records
  income: [
    {
      id: 1,
      source: "Project Payment",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      date: "2024-02-15",
      paymentMethod: "Bank Transfer",
      status: "received",
      notes: "First milestone payment",
    },
    {
      id: 2,
      source: "Project Payment",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      date: "2024-03-15",
      paymentMethod: "Bank Transfer",
      status: "received",
      notes: "Second milestone payment",
    },
    {
      id: 3,
      source: "Project Payment",
      projectId: 3,
      clientId: 3,
      amount: 300000,
      date: "2024-02-28",
      paymentMethod: "Bank Transfer",
      status: "received",
      notes: "Final payment",
    },
    {
      id: 4,
      source: "Project Payment",
      projectId: 2,
      clientId: 2,
      amount: 75000,
      date: "2024-03-10",
      paymentMethod: "UPI",
      status: "received",
      notes: "Advance payment",
    },
    {
      id: 5,
      source: "Project Payment",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      date: "2024-04-15",
      paymentMethod: "Bank Transfer",
      status: "pending",
      notes: "Final payment pending",
    },
  ],

  // Expense Records
  expenses: [
    {
      id: 1,
      name: "Office Rent",
      category: "Operations",
      amount: 50000,
      date: "2024-03-01",
      paymentMethod: "Bank Transfer",
      notes: "March rent",
    },
    {
      id: 2,
      name: "Software Subscriptions",
      category: "Tools",
      amount: 15000,
      date: "2024-03-05",
      paymentMethod: "Credit Card",
      notes: "Adobe, AWS, etc.",
    },
    {
      id: 3,
      name: "Employee Salaries",
      category: "Payroll",
      amount: 355000,
      date: "2024-03-25",
      paymentMethod: "Bank Transfer",
      notes: "March salaries",
    },
    {
      id: 4,
      name: "Marketing Campaign",
      category: "Marketing",
      amount: 25000,
      date: "2024-03-10",
      paymentMethod: "UPI",
      notes: "Google Ads",
    },
    {
      id: 5,
      name: "Office Supplies",
      category: "Operations",
      amount: 5000,
      date: "2024-03-12",
      paymentMethod: "Cash",
      notes: "Stationery and supplies",
    },
  ],

  // Portfolio Projects
  portfolio: [
    {
      id: 1,
      title: "E-Commerce Platform",
      category: "E-Commerce",
      description:
        "A full-featured e-commerce platform with payment integration, inventory management, and admin dashboard.",
      technologies: ["React", "Node.js", "MongoDB", "Stripe"],
      images: ["/portfolio/ecommerce-1.jpg", "/portfolio/ecommerce-2.jpg"],
      liveUrl: "https://example-ecommerce.com",
      status: "published",
      createdAt: "2024-02-28",
    },
    {
      id: 2,
      title: "Healthcare Management System",
      category: "Healthcare",
      description:
        "Patient management system with appointment scheduling, medical records, and billing.",
      technologies: ["React", "Python", "PostgreSQL", "AWS"],
      images: ["/portfolio/healthcare-1.jpg"],
      liveUrl: "https://example-healthcare.com",
      status: "published",
      createdAt: "2024-01-15",
    },
    {
      id: 3,
      title: "Real Estate Portal",
      category: "Real Estate",
      description:
        "Property listing portal with search filters, virtual tours, and agent management.",
      technologies: ["Next.js", "Node.js", "MySQL", "Google Maps API"],
      images: ["/portfolio/realestate-1.jpg"],
      liveUrl: "https://example-realestate.com",
      status: "draft",
      createdAt: "2024-03-10",
    },
  ],

  // Website Content
  websiteContent: {
    termsAndConditions:
      "<h2>Terms and Conditions</h2><p>Welcome to Techoside. By accessing our services, you agree to these terms...</p>",
    privacyPolicy:
      "<h2>Privacy Policy</h2><p>At Techoside, we value your privacy. This policy explains how we collect and use your data...</p>",
    aboutUs:
      "<h2>About Techoside</h2><p>We are a technology company dedicated to delivering innovative digital solutions...</p>",
    services:
      "<h2>Our Services</h2><p>We offer web development, mobile app development, UI/UX design, and more...</p>",
    contactDetails: {
      address: "123 Tech Street, Innovation City, IN 400001",
      phone: "+91 9876543210",
      email: "contact@techoside.com",
      workingHours: "Monday - Friday, 9:00 AM - 6:00 PM",
    },
  },

  // Notifications
  notifications: [
    {
      id: 1,
      type: "document",
      message: "New document uploaded by TechStart Inc.",
      read: false,
      createdAt: "2024-03-20T10:30:00",
    },
    {
      id: 2,
      type: "payment",
      message: "Payment of ₹50,000 received from TechStart Inc.",
      read: false,
      createdAt: "2024-03-15T14:00:00",
    },
    {
      id: 3,
      type: "project",
      message: "Project 'Digital Solutions Mobile App' moved to Design phase",
      read: true,
      createdAt: "2024-03-15T09:00:00",
    },
    {
      id: 4,
      type: "deadline",
      message: "Deadline approaching: TechStart Website Redesign (5 days left)",
      read: false,
      createdAt: "2024-03-25T08:00:00",
    },
    {
      id: 5,
      type: "client",
      message: "New client registered: Sarah Johnson",
      read: true,
      createdAt: "2024-02-20T11:30:00",
    },
  ],

  // Invoices
  invoices: [
    {
      id: 1,
      invoiceNumber: "INV-2024-001",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      tax: 9000,
      total: 59000,
      status: "paid",
      dueDate: "2024-02-28",
      paidDate: "2024-02-15",
      createdAt: "2024-02-01",
    },
    {
      id: 2,
      invoiceNumber: "INV-2024-002",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      tax: 9000,
      total: 59000,
      status: "paid",
      dueDate: "2024-03-30",
      paidDate: "2024-03-15",
      createdAt: "2024-03-01",
    },
    {
      id: 3,
      invoiceNumber: "INV-2024-003",
      projectId: 1,
      clientId: 1,
      amount: 50000,
      tax: 9000,
      total: 59000,
      status: "pending",
      dueDate: "2024-04-30",
      paidDate: null,
      createdAt: "2024-04-01",
    },
    {
      id: 4,
      invoiceNumber: "INV-2024-004",
      projectId: 2,
      clientId: 2,
      amount: 75000,
      tax: 13500,
      total: 88500,
      status: "paid",
      dueDate: "2024-03-20",
      paidDate: "2024-03-10",
      createdAt: "2024-03-01",
    },
  ],

  // Messages (Client-Admin communication)
  messages: [
    {
      id: 1,
      projectId: 1,
      clientId: 1,
      messages: [
        {
          id: 1,
          sender: "client",
          text: "Hi, can you provide an update on the homepage design?",
          timestamp: "2024-03-18T10:00:00",
        },
        {
          id: 2,
          sender: "admin",
          text: "Sure! The homepage design is 90% complete. We'll share the final mockup by tomorrow.",
          timestamp: "2024-03-18T10:30:00",
        },
        {
          id: 3,
          sender: "client",
          text: "Great, looking forward to it!",
          timestamp: "2024-03-18T10:35:00",
        },
      ],
    },
    {
      id: 2,
      projectId: 2,
      clientId: 2,
      messages: [
        {
          id: 1,
          sender: "admin",
          text: "Welcome to your project dashboard! Feel free to reach out if you have any questions.",
          timestamp: "2024-03-05T09:00:00",
        },
        {
          id: 2,
          sender: "client",
          text: "Thank you! When can we expect the first wireframes?",
          timestamp: "2024-03-05T11:00:00",
        },
        {
          id: 3,
          sender: "admin",
          text: "Wireframes will be ready by March 15th.",
          timestamp: "2024-03-05T11:30:00",
        },
      ],
    },
  ],
};

// Initialize mock data in localStorage
// Data version - increment this when mock data structure changes
const DATA_VERSION = 2;

export const initializeMockData = () => {
  const existingData = localStorage.getItem("techoside_data");
  const existingVersion = localStorage.getItem("techoside_data_version");
  
  // Reset data if version mismatch or no data exists
  if (!existingData || existingVersion !== String(DATA_VERSION)) {
    localStorage.setItem("techoside_data", JSON.stringify(initialMockData));
    localStorage.setItem("techoside_data_version", String(DATA_VERSION));
  }
};

// Get all data
export const getMockData = () => {
  const data = localStorage.getItem("techoside_data");
  if (data) {
    const parsed = JSON.parse(data);
    // Ensure admins array exists (backward compatibility)
    if (!parsed.admins) {
      parsed.admins = initialMockData.admins;
      updateMockData(parsed);
    }
    return parsed;
  }
  return initialMockData;
};

// Update data
export const updateMockData = (newData) => {
  localStorage.setItem("techoside_data", JSON.stringify(newData));
};

// Reset to initial data
export const resetMockData = () => {
  localStorage.setItem("techoside_data", JSON.stringify(initialMockData));
  localStorage.setItem("techoside_data_version", String(DATA_VERSION));
};
